import { Platform, StyleSheet, View } from "react-native";

import { StatusBanner } from "@luna-restaurant/ui";

import { useStatusBanner } from "@/hooks/useStatusBanner";

const WEB_STICKY_STYLE = {
  position: "sticky",
  top: 0,
  zIndex: 10,
} as any;

export const StatusBannerHost = () => {
  const { state, clearStatusBanner } = useStatusBanner();

  if (!state) {
    return null;
  }

  return (
    <View style={[styles.inner, Platform.OS === "web" && WEB_STICKY_STYLE]}>
      <StatusBanner
        key={state.id}
        {...state.banner}
        onDismiss={clearStatusBanner}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  inner: {
    width: "100%",
    paddingHorizontal: 40,
    paddingVertical: 32,
    backgroundColor: "#fff",
  },
});
